import { isEmpty } from 'ramda';

import { IApplicationState } from '../../types/redux';
import { selectDealType } from '../page';
import {
  EKey,
  EValue,
  IEstimationUserChosenFiltersSchema,
  IEstimationUserChosenFiltersSchema as IFiltersForApi,
} from '../../repositories/price-estimator/entities/estimation/EstimationUserChosenFiltersSchema';

export const selectPreciseFiltersContent = (state: IApplicationState) => {
  const dealType = selectDealType(state);

  return state.preciseFilters.data[dealType];
};

export const selectPreciseFiltersState = (state: IApplicationState) => state.preciseFilters.ui;

/** Возвращает список выбранных точных фильтров, подготовленных для API */
export const selectMappedPreciseFilters = (state: IApplicationState): IFiltersForApi[] => {
  const preciseFiltersApplied = selectPreciseFiltersState(state);

  if (isEmpty(preciseFiltersApplied)) {
    return [];
  }

  return Object.keys(preciseFiltersApplied)
    .map((key: keyof typeof preciseFiltersApplied) => {
      const value = preciseFiltersApplied[key];

      /**
       * В целом такого кейса не должно быть, но по типам может быть
       */
      if (!value) {
        return;
      }

      return {
        key: key as unknown as EKey,
        value: value as unknown as EValue[],
      };
    })
    .filter(Boolean) as IEstimationUserChosenFiltersSchema[];
};
